/**
 * Descargas del panel que NO son una URL pública (`/uploads/...`).
 *
 * El backend manda el archivo como respuesta AUTENTICADA (`Authorization: Bearer`), así que un
 * `<a href="/api/…">` no sirve: el navegador no adjuntaría el token en esa navegación. El camino es
 * `fetch` → `Blob` → un `<a download>` temporal, que dispara la descarga con el nombre de archivo que
 * elige el panel (el `Content-Disposition` del backend no lo puede leer el JS si el origen es otro,
 * salvo que el backend lo exponga por CORS).
 *
 * `URL.createObjectURL` retiene el blob en memoria hasta que se revoca, así que se revoca en el mismo
 * tick: para cuando eso pasa, el navegador ya tomó el archivo.
 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
